// Polyfill
import "intersection-observer";
import objectFitImages from "object-fit-images";
import closetPolyfill from "./lib/closet.polyfill";
objectFitImages();
closetPolyfill();

// Librally
// ---------------------------------------
import Swiper, { Autoplay, Navigation } from "swiper";
import "swiper/css";
Swiper.use([Navigation, Autoplay]);

import Toggle from "./lib/Toggle";
// import ScrollObserver from './lib/ScrollObserver';
// import { inview } from './lib/inview';

import "./lib/scrollNavbar"; // navigation ba
import "./lib/toggleSideVisible"; // single-template toggle sidebar visibility
import "./lib/clipcopy"; // copyurl
import "./lib/countfav"; // count favs
import "./lib/toclist"; // set toc list
import "./lib/fixedSidebar"; // material sidebar
import "./lib/ctaFixed"; // material sidebar

import { doc } from "prettier";

(() => {
  /**
   * toggle
   * --- header megamenu
   * --- header search form
   * --- single toc
   *
   */
  const trigger_buttons = [".js-tocbtn", ".js-searchbtn", ".js-megamenu",  ".js-material-nav"];
  // megamenu
  const header_megamenu = new Toggle(".js-megamenu", {
    hiddenTarget: ".p-header__megamenu",
  });
  // search form
  const header_searchform = new Toggle(".js-searchbtn", {
    hiddenTarget: ".p-header__searchform",
  });
  // toc
  const toc = new Toggle(".js-tocbtn", {
    hiddenTarget: ".p-single__toc",
  });

  const toc_closebtn = document.querySelector("#single-toc .js-closebtn");

  function disableScroll(event) {
    event.preventDefault();
  }

  // モーダルを開いたらスクロールイベントを無効にする
  // trigger_buttons.forEach((elm) => {
  //   if (document.querySelector(elm) != null) {
  //     document.querySelector(elm).addEventListener("click", () => {
  //       document.addEventListener("touchmove", disableScroll, { passive: false });
  //       document.addEventListener("mousewheel", disableScroll, { passive: false });
  //     });
  //   }
  // });

  const closeModal = () => {
    document.querySelector("html").classList.remove("-noScrolling");

    document.removeEventListener("touchmove", disableScroll, { passive: false });
    document.removeEventListener("mousewheel", disableScroll, { passive: false });

    //検索フォームを閉じる
    document.querySelector("html").classList.remove("is-searchbtnActive");
    document.querySelector("#header-searchform").setAttribute("aria-hidden", "true");
    document.querySelector(".js-searchbtn").setAttribute("aria-expanded", "false");

    // ヘッダーメニューを閉じる
    document.querySelector("html").classList.remove("is-megamenuActive");
    document.querySelector("#megamenu").setAttribute("aria-hidden", "true");
    document.querySelector(".js-megamenu").setAttribute("aria-expanded", "false");

    // TOCリストを閉じる
    if (toc_closebtn != undefined && toc_closebtn != null) {
      document.querySelector("html").classList.remove("is-tocbtnActive");
      document.querySelector("#single-toc").setAttribute("aria-hidden", "true");
      document.querySelector(".js-tocbtn").setAttribute("aria-expanded", "false");
    }
  };

  // Escape ボタンをクリックした時
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeModal();
    }
  });

  // close ボタンをクリックした時
  document.querySelectorAll(".js-closebtn").forEach((btn) => {
    btn.addEventListener("click", () => {
      closeModal();
    });
  });

  /**
   * Smooth scroll
   *
   */

  const links = document.querySelectorAll('a[href^="#"]');

  for (const link of links) {
    link.addEventListener("click", clickHandler);
  }

  function clickHandler(e) {
    e.preventDefault();
    const scroll_offset = 100;
    const href = this.getAttribute("href");
    const offsetTop = document.querySelector(href).offsetTop - scroll_offset;

    closeModal();

    scroll({
      top: offsetTop,
      behavior: "smooth",
    });
  }

  /**
   * Swiper slider
   *
   */
  if (document.querySelector(".js-contnetslider") != undefined && document.querySelector(".js-contnetslider") != null) {
    const swiper = new Swiper(".js-contnetslider", {
      slidesPerView: 1,
      speed: 2000,
      spaceBetween: 2,
      loop: true,
      autoplay: {
        delay: 1500,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  // slideUp
  const slideUp = (el, duration = 300) => {
    el.style.height = el.offsetHeight + "px";
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.setAttribute("aria-hidden", "true");
    setTimeout(() => {
      el.style.display = "none";
      el.style.removeProperty("height");
      el.style.removeProperty("padding-top");
      el.style.removeProperty("padding-bottom");
      el.style.removeProperty("margin-top");
      el.style.removeProperty("margin-bottom");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  };

  // slideDown
  const slideDown = (el, duration = 300) => {
    el.style.removeProperty("display");
    let display = window.getComputedStyle(el).display;
    if (display === "none") {
      display = "block";
    }
    el.style.display = display;
    let height = el.offsetHeight;
    el.style.overflow = "hidden";
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight;
    el.style.transitionProperty = "height, margin, padding";
    el.style.transitionDuration = duration + "ms";
    el.style.transitionTimingFunction = "ease";
    el.style.height = height + "px";
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.setAttribute("aria-hidden", "false");
    setTimeout(() => {
      el.style.removeProperty("height");
      el.style.removeProperty("overflow");
      el.style.removeProperty("transition-duration");
      el.style.removeProperty("transition-property");
      el.style.removeProperty("transition-timing-function");
    }, duration);
  };

  // slideToggle
  const slideToggle = (el, duration = 300) => {
    if (window.getComputedStyle(el).display === "none") {
      el.previousElementSibling.classList.add("is-open");
      return slideDown(el, duration);
    } else {
      el.previousElementSibling.classList.remove("is-open");
      return slideUp(el, duration);
    }
  };

  // ボタン
  const slideUpBtn = document.querySelector(".slide-up-btn");
  const slideDownBtn = document.querySelector(".slide-down-btn");
  const slideToggleBtn = document.querySelectorAll(".js-accordion");

  // // slideUp
  // slideUpBtn.addEventListener("click", () => {
  //   slideUp(el, 300);
  // });

  // // slideDown
  // slideDownBtn.addEventListener("click", () => {
  //   slideDown(el, 300);
  // });

  // slideToggle
  if (slideToggleBtn != undefined && slideToggleBtn != null) {
    slideToggleBtn.forEach((btn) => {
      if (btn.nextElementSibling != null) {
        btn.nextElementSibling.style.display = "none";

        btn.addEventListener("click", () => {
          let el = btn.nextElementSibling;
          slideToggle(el, 100);
        });
      }
    });
  }

  // megamenu categorylist
  if (document.querySelector(".js-menuaccordion") != undefined && document.querySelector(".js-menuaccordion") != null) {
    if (document.querySelector(".menu-categorylist") != null) {
      document.querySelector(".js-menuaccordion").addEventListener("click", () => {
        let el = document.querySelector(".menu-categorylist");
        slideToggle(el, 300);
      });
    }
  }

  // Twitter box
  const tweetToggle = document.querySelector(".js-toggle-tweetbox");
  if (tweetToggle != undefined && tweetToggle != null) {
    tweetToggle.addEventListener("click", (e) => {
      if (document.querySelector(".js-toggle-tweetbox").getAttribute("aria-expanded") == "true") {
        document.querySelector(".js-toggle-tweetbox").setAttribute("aria-expanded", "false");
      } else {
        document.querySelector(".js-toggle-tweetbox").setAttribute("aria-expanded", "true");
      }
      let el = document.querySelector("#tweet-box");
      slideToggle(el, 300);
    });
  }

  /**
   * tablist
   *
   */
  const tablist = document.querySelectorAll(".js-tablist");

  tablist.forEach((list) => {
    const tabbutton = list.querySelectorAll(".tablist-button");
    const tabpanel = list.querySelectorAll(".tablist-panel");
    const buttons_array = [];

    tabbutton.forEach((button, index) => {
      // それぞれのボタンのaria-controlsを格納
      buttons_array.push(button.getAttribute("aria-controls").replace("ranking-", ""));

      button.addEventListener("click", (e) => {
        let index = [].slice.call(tabbutton).indexOf(button);
        let controls = e.target.getAttribute("aria-controls");
        // console.log(controls);
        controls = controls.replace("ranking-", "");

        // 現在の表示追加
        buttons_array.forEach((controls) => {
          // console.log(controls);
          list.classList.remove(`is-${controls}Selected`);
        });
        list.classList.add(`is-${controls}Selected`);

        // タブボタンの切り替え
        tabbutton.forEach((elm) => {
          elm.classList.remove("is-active");
          elm.setAttribute("aria-expanded", "false");
        });

        // タブパネルの切り替え
        tabpanel.forEach((elm) => {
          elm.classList.remove("is-active");
          elm.setAttribute("aria-hidden", "true");
        });

        tabpanel[index].classList.add("is-active");
        tabpanel[index].setAttribute("aria-hidden", "false");
      });
    });
  });

  /**
   * pickup item toggle
   *
   */
  const summary = document.querySelectorAll(".js-summary");
  const summary_btn = document.querySelectorAll(".js-summary__btn");

  summary_btn.forEach((btn, index) => {
    btn.addEventListener("click", (e) => {
      const e_summary = summary[index];
      const flag = e_summary.classList.contains("is-open");

      if (!flag) {
        e.target.classList.add("is-open");
        e_summary.classList.add("is-open");
      } else {
        e.target.classList.remove("is-open");
        e_summary.classList.remove("is-open");
      }
    });
  });

  /**
   * mediumZoom
   *
   */
  mediumZoom(document.querySelectorAll(".wp-block-image:not(.is-notzoom) img"), {
    margin: 70,
    background: "#1D2128",
    scrollOffset: 50,
  });

  //ホバーで「画像を拡大できます」を表示
  const wpblockimage = document.querySelectorAll('.wp-block-image');
  wpblockimage.forEach((img) => {
    img.addEventListener("mouseover", (e) => {
      img.classList.add("is-over");
      img.classList.remove("is-leave");
    });
    img.addEventListener("mouseleave", (e) => {
      img.classList.add("is-leave");
      img.classList.remove("is-over");
    });
  })

  /**
   * 教材ページ固定ナビ
   *
   */
   const materialNav_btn = document.querySelectorAll(".js-material-nav__parent");
   const materialNav = document.querySelectorAll(".js-material-nav__children");
 
   materialNav_btn.forEach((btn, index) => {
     btn.addEventListener("click", (e) => {
       const e_materialNav = materialNav[index];
       const flag = e_materialNav.classList.contains("is-open");
       if (!flag) {
          e.target.classList.add("is-open");
          e_materialNav.classList.add("is-open");
          e.target.setAttribute("aria-hidden", "false");
          e_materialNav.setAttribute("aria-expanded", "true");
       } else {
          e.target.setAttribute("aria-hidden", "true");
          e_materialNav.setAttribute("aria-expanded", "false");
          e.target.classList.remove("is-open");
          e_materialNav.classList.remove("is-open");
       }
     });
   });
   


})();
